const BoltAILogo = () => {
  return (
    <img
      src="/app/images/logos/boltai.png"
      width="28"
      height="28"
      alt="BoltAI"
    />
  );
};

export default BoltAILogo;
